import { APP_ID } from '../../brand';

/**
 * Clave de almacenamiento con el prefijo de la aplicación.
 *
 * Todo lo que se guarda pasa por aquí, así que nada puede chocar con otra aplicación servida
 * desde el mismo origen, y renombrar el producto no deja claves huérfanas repartidas.
 */
export function storageKey(name: string): string {
  return `${APP_ID}.${name}`;
}

/**
 * Acceso a `localStorage` que nunca lanza.
 *
 * En navegación privada, con las cookies de terceros bloqueadas o dentro de un iframe sin
 * permisos, incluso *leer* `localStorage` lanza. Una preferencia guardada no vale tumbar la
 * pantalla, así que todos los fallos degradan a "no hay valor guardado".
 */
export function readJson<T>(key: string): T | null {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function writeJson(key: string, value: unknown): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Cuota llena o almacenamiento bloqueado: se pierde la preferencia, no la sesión.
  }
}

export function remove(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // Ídem.
  }
}
